import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import { Header } from '@/components/Generic'
import { forceRedirect } from '@/methods/forceRedirect'
import { Illustration } from '@/components/Illustration/Illustration'

export const ErrorEnpalPage = observer(() => {
  const store = useContext(StoreContext)
  const { errorEnpalPage: trans } = store.TranslationsState.translations

  const path = window.location.pathname.split('/')[1]

  // Type guard function
  const isValidTransKey = (key: string): key is keyof typeof trans => {
    return key in trans
  }

  if (!isValidTransKey(path)) {
    forceRedirect('/error')
    return <></>
  }

  return (
    <div className="page-container mobile-m-0">
      <Illustration type="error" />
      <Header className="m-0-0-30">{trans[path].title}</Header>
      <p className="generic__paragraph-centered m-0-0-30">{trans[path].dearCustomer}</p>

      <div className="enpal__step">
        <div className="npal__circle">1</div>
        <div className="enpal__info-text">{trans[path].step1}</div>
      </div>
      <div className="generic__spacer h-8" />
      <div className="enpal__step">
        <div className="npal__circle">2</div>
        <div className="enpal__info-text">{trans[path].step2}</div>
      </div>
    </div>
  )
})
